module.exports = __webpack_public_path__ + "static/media/truck_red_temp_red.247c2ffd.png";